import CustomerFullName from 'components/common/CustomerFullName';
import Price from 'components/common/Price';
import axios from 'helpers/axios';
import config from 'helpers/config';
import AccountReceivableModel from 'models/AccountReceivableModel';
import React from 'react';
import { Link } from 'react-router-dom';

interface State {
    accountsReceivable: AccountReceivableModel[];
}
interface Props {}

class AccountsReceivableList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            accountsReceivable: [],
        };
    }

    componentDidMount() {
        axios
            .get(`${config.apiUrl}/misc/accountsReceivable`)
            .then((res) => {
                this.setState({ accountsReceivable: res.data });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    render() {
        const { accountsReceivable } = this.state;
        return (
            <div>
                <h1>Accounts Receivable List</h1>
                <div className="mt-4 overflow-x-auto ">
                    <table className="items-center bg-transparent border w-full">
                        <thead className="border">
                            <tr className=" bg-blue-600 text-white border-none font-semibold text-left text-xs uppercase align-middle">
                                <th className="pl-6 py-3 rounded-tl-xl">RO #</th>
                                <th className="px-6 py-3">RO Total</th>
                                <th className="px-6 py-3">Balance Due</th>
                                <th className="px-6 py-3">Customer</th>
                                <th className="px-6 py-3">Due Date</th>
                                <th className="px-6 py-3 rounded-tr-xl">Vehicle</th>
                            </tr>
                        </thead>

                        <tbody>
                            {accountsReceivable?.map((AR, index) => (
                                <tr
                                    className={`border group font-medium hover:bg-blue-200 clickable ${
                                        index % 2 === 0 ? 'bg-gray-100' : 'bg-blue-100'
                                    }`}
                                    key={AR.repairOrder?.id}
                                >
                                    <td className="px-6 min-w-max align-middle border-l-0 border-r-0 text-base whitespace-nowrap py-2 text-left flex items-center">
                                        <span className="font-semibold text-gray-500">
                                            <Link to={`/repairOrder/${AR.repairOrder?.id}`}>
                                                RO#: {AR.repairOrder?.repairOrderNumber}
                                            </Link>
                                        </span>
                                    </td>
                                    <td className="px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap py-2">
                                        <span className=" text-green-400">
                                            <Price price={AR.total / 100} />
                                        </span>
                                    </td>
                                    <td className="px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap py-2">
                                        <span className="font-semibold text-green-400">
                                            <Price price={AR.balanceDue / 100} />
                                        </span>
                                    </td>
                                    <td className="px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap py-2">
                                        <span className="font-semibold text-gray-500">
                                            <Link to={`/customer/${AR.repairOrder?.customerId}`}>
                                                <CustomerFullName customerId={AR.repairOrder?.customerId!} />
                                            </Link>
                                        </span>
                                    </td>

                                    <td className="px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap py-2">
                                        <span className="font-semibold text-gray-500">
                                            <Link to={`/customer/${AR.repairOrder?.customerId}`}>
                                                <CustomerFullName customerId={AR.repairOrder?.customerId!} />
                                            </Link>
                                        </span>
                                    </td>
                                    <td className="px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap py-2">
                                        <div>
                                            {!!AR.vehicle ? (
                                                <div>
                                                    <div>
                                                        <span>
                                                            {AR.vehicle?.year} {AR.vehicle?.make} {AR.vehicle?.model}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <small>{AR.vehicle.VIN}</small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <span className="text-gray-400 font-medium">No vehicle</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {accountsReceivable?.length! < 1 && (
                        <div className="border py-4 px-4 wb-white text-gray-600 text-lg font-semibold text-center">
                            Your repair shop has no accounts receivable.
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default AccountsReceivableList;
